/* eslint-disable */
export default {
  _TempleBckgDays: 'TempleBckgDays',
  _BckgWithoutTree: 'BckgWithoutTree',
  _ProgressBarDays: 'ProgressBarDays',
  _drag_instructions: 'drag_instructions',
  _Eyes2: 'Eyes2',
  _Eyes3: 'Eyes3',
  _Eyes4: 'Eyes4',
  _Eyes1: 'Eyes1',
  _ProgressBar10Days: 'ProgressBar10Days',
  _ProgressBar1Days: 'ProgressBar1Days',
  _ProgressBar2Days: 'ProgressBar2Days',
  _ProgressBar9Days: 'ProgressBar9Days',
  _ProgressBar3Days: 'ProgressBar3Days',
  _ProgressBar8Days: 'ProgressBar8Days',
  _ProgressBar4Days: 'ProgressBar4Days',
  _ProgressBar7Days: 'ProgressBar7Days',
  _ProgressBar5Days: 'ProgressBar5Days',
  _ProgressBar6Days: 'ProgressBar6Days',
  _Coin: 'Coin',
  _ProgressBar1HighlightDays: 'ProgressBar1HighlightDays',
  _ProgressBar10HighlightDays: 'ProgressBar10HighlightDays',
  _ProgressBar2HighlightDays: 'ProgressBar2HighlightDays',
  _ProgressBar9HighlightDays: 'ProgressBar9HighlightDays',
  _ProgressBar3HighlightDays: 'ProgressBar3HighlightDays',
  _ProgressBar7HighlightDays: 'ProgressBar7HighlightDays',
  _ProgressBar8HighlightDays: 'ProgressBar8HighlightDays',
  _ProgressBar4HighlightDays: 'ProgressBar4HighlightDays',
  _ProgressBar5HighlightDays: 'ProgressBar5HighlightDays',
  _ProgressBar6HighlightDays: 'ProgressBar6HighlightDays',
  _MuteBtn: 'MuteBtn',
  _title_man: 'title_man',
  _QuestionBckgDays: 'QuestionBckgDays',
  _ChestInside: 'ChestInside',
  _UnmuteBtnDays: 'UnmuteBtnDays',
  _ChestInsideAndFront: 'ChestInsideAndFront',
  _ChestLidDays: 'ChestLidDays',
  _TileSlot2Days: 'TileSlot2Days',
  _PopupBckg: 'PopupBckg',
  _LogoDays: 'LogoDays',
  _jump_18: 'jump/18',
  _jump_19: 'jump/19',
  _jump_20: 'jump/20',
  _TileSlot1Days: 'TileSlot1Days',
  _FridayTile: 'FridayTile',
  _jump_17: 'jump/17',
  _jump_21: 'jump/21',
  _TileSlot3Days: 'TileSlot3Days',
  _TileSlot4Days: 'TileSlot4Days',
  _TileSlot5Days: 'TileSlot5Days',
  _TileSlot6Days: 'TileSlot6Days',
  _TileSlot7Days: 'TileSlot7Days',
  _SaturdayTile: 'SaturdayTile',
  _SundayTile: 'SundayTile',
  _WednesdayTile: 'WednesdayTile',
  _MondayTile: 'MondayTile',
  _FridayBtn: 'FridayBtn',
  _OutsideBckgDays: 'OutsideBckgDays',
  _TempleWall: 'TempleWall',
  _ForegroundTree: 'ForegroundTree',
  _jump_15: 'jump/15',
  _MondayBtn: 'MondayBtn',
  _SaturdayBtn: 'SaturdayBtn',
  _jump_16: 'jump/16',
  _SundayBtn: 'SundayBtn',
  _jump_22: 'jump/22',
  _jump_23: 'jump/23',
  _ThursdayBtn: 'ThursdayBtn',
  _TuesdayBtn: 'TuesdayBtn',
  _jump_14: 'jump/14',
  _jump_24: 'jump/24',
  _jump_25: 'jump/25',
  _WednesdayBtn: 'WednesdayBtn',
  _jump_13: 'jump/13',
  _jump_26: 'jump/26',
  _jump_27: 'jump/27',
  _ThursdayTile: 'ThursdayTile',
  _TuesdayTile: 'TuesdayTile',
  _jump_0: 'jump/0',
  _jump_1: 'jump/1',
  _jump_12: 'jump/12',
  _jump_28: 'jump/28',
  _jump_35: 'jump/35',
  _jump_2: 'jump/2',
  _jump_34: 'jump/34',
  _TempleDoorRight: 'TempleDoorRight',
  _jump_11: 'jump/11',
  _jump_29: 'jump/29',
  _jump_3: 'jump/3',
  _jump_33: 'jump/33',
  _ContinueBtnDays: 'ContinueBtnDays',
  _jump_4: 'jump/4',
  _TempleDoorLeft: 'TempleDoorLeft',
  _jump_10: 'jump/10',
  _jump_30: 'jump/30',
  _jump_5: 'jump/5',
  _jump_32: 'jump/32',
  _jump_6: 'jump/6',
  _jump_31: 'jump/31',
  _jump_7: 'jump/7',
  _jump_8: 'jump/8',
  _jump_9: 'jump/9',
  _PlatformDays: 'PlatformDays',
  _PlayAgainBtnDays: 'PlayAgainBtnDays',
}